import searchComponent from './searchComponent';

/**
 * Calls the given function for each component in the component tree.
 * If the function returns exactly value `false`, then the iteration stops.
 */

export default function traverseComponent<C extends { children: C[] }>(
  rootComponent: C,
  fn: (descendant: C, depth: number) => boolean | void,
): void {
  searchComponent(rootComponent, (...args) => fn(...args) === false);
}
